export default "__VITE_ASSET__O25_Ub0Q__"